import {Deserializable} from "./deserializable.model";

export class CostTask {

    cost_task_id: number;
    cost_task_name: string;
    myob_tax_code_id: any;
    myob_account_code_id: any;
    cost_task_description: string;
    brand_type_id: any;
    job_type_id: any;
    cost_task_fee: any;



  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): CostTask {
    Object.assign(this, input);

    return this;
  }

  /*
billing_task_id
billing_task_name
tax_code_id
myob_account_code_id
billing_task_description
brand_type_id
job_type_id
billing_task_fee
  */


}
